import { render, staticRenderFns } from "./extra-it-ticket-vorgang-aufgeben.vue?vue&type=template&id=6af39946&lang=pug&"
import script from "./extra-it-ticket-vorgang-aufgeben.vue?vue&type=script&lang=js&"
export * from "./extra-it-ticket-vorgang-aufgeben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports